import { createElementVNode as _createElementVNode, renderList as _renderList, Fragment as _Fragment, openBlock as _openBlock, createElementBlock as _createElementBlock, resolveComponent as _resolveComponent, withCtx as _withCtx, createBlock as _createBlock, createVNode as _createVNode, normalizeClass as _normalizeClass, createCommentVNode as _createCommentVNode, toDisplayString as _toDisplayString, normalizeStyle as _normalizeStyle, createTextVNode as _createTextVNode, withModifiers as _withModifiers, pushScopeId as _pushScopeId, popScopeId as _popScopeId } from "vue";
const _withScopeId = n => (_pushScopeId("data-v-8668c9c8"), n = n(), _popScopeId(), n);
const _hoisted_1 = /*#__PURE__*/_withScopeId(() => /*#__PURE__*/_createElementVNode("div", {
  class: "nav"
}, [/*#__PURE__*/_createElementVNode("strong", null, "摩点抽卡")], -1));
const _hoisted_2 = {
  key: 0,
  class: "luckycards-banner-box"
};
const _hoisted_3 = ["href"];
const _hoisted_4 = ["src"];
const _hoisted_5 = /*#__PURE__*/_withScopeId(() => /*#__PURE__*/_createElementVNode("i", null, null, -1));
const _hoisted_6 = {
  class: "custom-indicator"
};
const _hoisted_7 = ["onClick"];
const _hoisted_8 = ["src"];
const _hoisted_9 = {
  class: "info"
};
const _hoisted_10 = {
  class: "name"
};
const _hoisted_11 = {
  class: "group-info"
};
const _hoisted_12 = {
  class: "group-status"
};
const _hoisted_13 = /*#__PURE__*/_withScopeId(() => /*#__PURE__*/_createElementVNode("span", {
  class: "label"
}, "组团", -1));
const _hoisted_14 = {
  class: "num"
};
const _hoisted_15 = {
  class: "group-info-progerss"
};
const _hoisted_16 = {
  class: "progress-num"
};
const _hoisted_17 = /*#__PURE__*/_createTextVNode("/");
const _hoisted_18 = ["onClick"];
const _hoisted_19 = /*#__PURE__*/_withScopeId(() => /*#__PURE__*/_createElementVNode("i", null, null, -1));
const _hoisted_20 = ["onClick"];
const _hoisted_21 = ["src"];
const _hoisted_22 = {
  class: "info"
};
const _hoisted_23 = {
  class: "name"
};
const _hoisted_24 = {
  class: "price"
};
const _hoisted_25 = {
  class: "fixed-btn"
};
const _hoisted_26 = /*#__PURE__*/_withScopeId(() => /*#__PURE__*/_createElementVNode("img", {
  src: "https://p6.moimg.net/mdwxapp/luckycards/share_btn.png"
}, null, -1));
const _hoisted_27 = [_hoisted_26];
export function render(_ctx, _cache, $props, $setup, $data, $options) {
  const _component_van_swipe_item = _resolveComponent("van-swipe-item");
  const _component_van_swipe = _resolveComponent("van-swipe");
  const _component_van_list = _resolveComponent("van-list");
  const _component_CompEWM = _resolveComponent("CompEWM");
  return _openBlock(), _createElementBlock("div", {
    class: _normalizeClass(['list-box render-hide-scroll', {
      'list-box-wx': $data.env.isWxApp()
    }])
  }, [_hoisted_1, $data.swipeList && $data.swipeList.length ? (_openBlock(), _createElementBlock("div", _hoisted_2, [_createVNode(_component_van_swipe, {
    autoplay: 5000,
    "lazy-render": "",
    "indicator-color": "#fff",
    onChange: $options.swipeChange,
    "show-indicators": false
  }, {
    default: _withCtx(() => [(_openBlock(true), _createElementBlock(_Fragment, null, _renderList($data.swipeList, (item, index) => {
      return _openBlock(), _createBlock(_component_van_swipe_item, {
        key: index
      }, {
        default: _withCtx(() => [_createElementVNode("a", {
          href: item.url
        }, [_createElementVNode("img", {
          src: _ctx.$imgUrlFilter(item.show_url, 742, 316)
        }, null, 8, _hoisted_4)], 8, _hoisted_3)]),
        _: 2
      }, 1024);
    }), 128))]),
    _: 1
  }, 8, ["onChange"]), _hoisted_5, _createElementVNode("div", _hoisted_6, [(_openBlock(true), _createElementBlock(_Fragment, null, _renderList($data.swipeList.length, item => {
    return _openBlock(), _createElementBlock("div", {
      key: item,
      class: _normalizeClass(['custom-indicator-item', {
        'active': item - 1 == $data.swipeIndex
      }])
    }, null, 2);
  }), 128))])])) : _createCommentVNode("", true), _createVNode(_component_van_list, {
    loading: $data.loading,
    "onUpdate:loading": _cache[0] || (_cache[0] = $event => $data.loading = $event),
    finished: $data.finished,
    "finished-text": "没有更多了",
    onLoad: $options.getList
  }, {
    default: _withCtx(() => [(_openBlock(true), _createElementBlock(_Fragment, null, _renderList($data.list, item => {
      return _openBlock(), _createElementBlock("div", {
        key: item,
        class: _normalizeClass(['collect-item-box', {
          'has-collect': item.is_collect
        }])
      }, [item.group_info && item.group_info.id ? (_openBlock(), _createElementBlock("div", {
        key: 0,
        class: "collect-item collect-item-group",
        onClick: _withModifiers($event => $options.goGroupInfo(item), ["stop"])
      }, [_createElementVNode("img", {
        class: "img",
        src: `${_ctx.$imgUrlFilter(item.list_main_image_url, 1280)}`
      }, null, 8, _hoisted_8), _createElementVNode("div", _hoisted_9, [_createElementVNode("div", _hoisted_10, _toDisplayString(item.name), 1)]), _createElementVNode("div", _hoisted_11, [_createElementVNode("div", _hoisted_12, [_hoisted_13, _createElementVNode("span", _hoisted_14, _toDisplayString(item.group_info.user_num) + "人已参团", 1)]), _createElementVNode("div", _hoisted_15, [_createElementVNode("div", {
        class: "progress-info",
        style: _normalizeStyle(`width: ${item.group_info.use_box_num / item.group_info.total_box_num * 100}%`)
      }, null, 4)]), _createElementVNode("div", _hoisted_16, [_createElementVNode("span", null, "余" + _toDisplayString(item.group_info.total_box_num - item.group_info.use_box_num), 1), _hoisted_17, _createElementVNode("text", null, "共" + _toDisplayString(item.group_info.total_box_num), 1)])])], 8, _hoisted_7)) : _createCommentVNode("", true), item.is_collect ? (_openBlock(), _createElementBlock("div", {
        key: 1,
        class: "collect-box",
        onClick: _withModifiers($event => $options.goCollect(item), ["stop"])
      }, [_createElementVNode("span", null, _toDisplayString(item.collect_name), 1), _hoisted_19], 8, _hoisted_18)) : _createCommentVNode("", true), _createElementVNode("div", {
        class: "collect-item",
        onClick: _withModifiers($event => $options.goInfo(item), ["stop"])
      }, [_createElementVNode("img", {
        class: "img",
        src: `${_ctx.$imgUrlFilter(item.list_main_image_url, 1280)}`
      }, null, 8, _hoisted_21), _createElementVNode("div", _hoisted_22, [_createElementVNode("div", _hoisted_23, _toDisplayString(item.name), 1), _createElementVNode("div", _hoisted_24, "￥" + _toDisplayString(item.sale_price), 1)])], 8, _hoisted_20)], 2);
    }), 128))]),
    _: 1
  }, 8, ["loading", "finished", "onLoad"]), !$data.env.isWxApp() ? (_openBlock(), _createElementBlock("div", {
    key: 1,
    class: "back",
    onClick: _cache[1] || (_cache[1] = (...args) => $options.goBack && $options.goBack(...args))
  })) : _createCommentVNode("", true), _createElementVNode("div", _hoisted_25, [!$data.env.isWxApp() ? (_openBlock(), _createElementBlock("div", {
    key: 0,
    class: "share-btn",
    onClick: _cache[2] || (_cache[2] = (...args) => $options.onShare && $options.onShare(...args))
  }, _hoisted_27)) : _createCommentVNode("", true)]), _createVNode(_component_CompEWM, {
    show: $data.showEWM,
    "onUpdate:show": _cache[3] || (_cache[3] = $event => $data.showEWM = $event)
  }, null, 8, ["show"])], 2);
}